<template>
  <div>
    <div id="footer">
      <router-link to="/"><i class="fa"></i><span>探索</span></router-link>
      <router-link to="/share"
        ><i class="fa"></i><span>共享</span></router-link
      >
      <router-link to="/mark"><i class="fa"></i><span>标记</span></router-link>
      <!-- <router-link to="/notice"
        ><i class="fa"></i><span>消息</span></router-link
      > -->
    </div>
  </div>
</template>

<script lang="">
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
@import "../assets/less/Footer.less";
</style>
